// extracted by mini-css-extract-plugin
export default {"base":"SVYHo","content":"Pf3VE","header":"l8Dy9","image":"jK3lU","center":"bcOXA","buttonGroup":"qccWr","heading":"ru1AU"};